/**
 * Synthetic "Req" (move requirements) column support.
 *
 * "req" is not a real DB field — it's a composite column rendered as icons
 * (see components/RequirementIcons.tsx). When a card has "req" selected,
 * the underlying flag fields below must be fetched instead.
 */

export const REQ_FIELD = 'req';

/** Real orderscurrent fields that drive the requirement icons. */
export const REQ_UNDERLYING_FIELDS = [
  'hot',
  'hazmat',
  'istank',
  'overweightpermitrequired',
  'temperaturecontrolled',
  'chassistype',
  'equiptype',
];

/**
 * Expand the synthetic "req" entry in an additional-fields list into the
 * underlying real fields for the API request. Leaves other fields untouched
 * and avoids duplicating fields the user already picked individually.
 */
export function expandAdditionalFields(fields: string[]): string[] {
  if (!fields.includes(REQ_FIELD)) return fields;
  const expanded = fields.filter(f => f !== REQ_FIELD);
  for (const field of REQ_UNDERLYING_FIELDS) {
    if (!expanded.includes(field)) {
      expanded.push(field);
    }
  }
  return expanded;
}
